import { createAsyncThunk } from "@reduxjs/toolkit";
import { CMS_PATHS } from "../../../../constants/textConstants";
import { AxiosResponse } from "axios";
import { DrupalResponseData } from "../types/node-data";
import { CMS_BASE_URL } from "config/config";
import { apiGet } from "api";

export const getKnownIssues = createAsyncThunk("support/getKnownIssues", async (_, { rejectWithValue }) => {
  try {
    const { data }: AxiosResponse<DrupalResponseData> = await apiGet({
      url: `${CMS_BASE_URL}${CMS_PATHS.knownIssues}`,
      params: {
        include: "tags",
      },
    });

    return data;
  } catch (error: any) {
    console.log({ error });
    return rejectWithValue("something went wrong");
  }
});
